import React from "react";
import { MessageCircle, Phone, MapPin } from "lucide-react";
import logo from "./images/logo.png";

function Footer({ setCurrentPage }) {
  try {
    const currentYear = new Date().getFullYear();

    const quickLinks = [
      { id: "home", label: "Home" },
      { id: "about", label: "About" },
      { id: "gallery", label: "Gallery" },
      { id: "booking", label: "Booking" },
      { id: "location", label: "Location" },
    ];

    return (
      <footer
        className="footer-modern"
        data-name="footer"
        data-file="components/Footer.js"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="lg:col-span-2">
              <div className="mb-4">
                <img
                  src={logo}
                  alt="Angelo's Farm Logo"
                  className="h-12 w-auto object-contain"
                />
              </div>
              <p className="mb-6 max-w-md">
                Experience luxury and comfort at Angelo's Farm - your perfect
                getaway destination in Kukas, Jaipur. 8BHK villa with pool,
                garden, and premium amenities.
              </p>
              {/* <div className="flex space-x-4">
                <a
                  href="#"
                  className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center hover:bg-orange-200 transition-colors"
                >
                  <div className="icon-instagram text-xl text-orange-700"></div>
                </a>
                <a
                  href="#"
                  className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center hover:bg-orange-200 transition-colors"
                >
                  <div className="icon-facebook text-xl text-orange-700"></div>
                </a>
              </div> */}
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                {quickLinks.map((link) => (
                  <li key={link.id}>
                    <button
                      onClick={() => {
                        setCurrentPage(link.id);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                      className="hover:text-orange-400 transition-colors"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-bold mb-4">Contact</h4>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                    <MapPin size={28} color="#B86A4B" />
                  </div>{" "}
                  <a
                    href="https://g.co/kgs/Tg8AN4E"
                    target="_blank"
                    rel="noopener noreferrer"
                    onMouseEnter={(e) => (e.target.style.color = "#B86A4B")}
                    onMouseLeave={(e) => (e.target.style.color = "")}
                    className="text-blue-600 italic hover:text-[#B86A4B] hover:underline"
                  >
                    Kukas, Jaipur
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                    <Phone size={28} color="#B86A4B" />
                  </div>{" "}
                  <div>
                    <p>+91 89493 48052</p>
                    <p>+91 92568 28782</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                    <MessageCircle size={28} color="#B86A4B" />
                  </div>{" "}
                  <span>24/7 Available</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-stone-200 mt-8 pt-8 flex flex-col md:flex-row justify-center items-center">
            <p className="text-stone-500 text-sm mb-4 md:mb-0">
              © {currentYear} Angelo's Farm. All rights reserved. crafted by{" "}
              <a
                href="https://www.cubixcode.in"
                target="_blank"
                rel="noopener noreferrer"
                onMouseEnter={(e) => (e.target.style.color = "#B86A4B")}
                onMouseLeave={(e) => (e.target.style.color = "")}
                className="text-blue-600 italic hover:text-[#B86A4B] hover:underline"
              >
                cubixcode
              </a>
            </p>
          </div>
        </div>
      </footer>
    );
  } catch (error) {
    console.error("Footer component error:", error);
    return null;
  }
}

export default Footer;
